<form [formGroup]="form" class="text-sm" *ngIf="form" (ngSubmit)="submitForm()">
  <div class="grid grid-cols-1 gap-5 mb-5">
    <div [ngClass]="form.controls['questionSR'].touched ? (form.controls['questionSR'].errors ? 'has-error' : 'has-success') : ''">
      <label for="questionSR">{{ "qna.questionSR" | translate }}</label>
      <input id="questionSR" type="text" placeholder="{{ 'qna.enter_questionSR' | translate }}" class="form-input" formControlName="questionSR" />
      <small class="text-danger" *ngIf="form.controls['questionSR'].errors && form.controls['questionSR'].touched">
        {{ "qna.please_provide_questionSR" | translate }}
      </small>
    </div>

    <div [ngClass]="form.controls['answerSR'].touched ? (form.controls['answerSR'].errors ? 'has-error' : 'has-success') : ''">
      <label for="answerSR">{{ "qna.answerSR" | translate }}</label>
      <textarea id="answerSR" type="text" placeholder="{{ 'qna.enter_answerSR' | translate }}" class="form-input h-40" formControlName="answerSR"></textarea>
      <small class="text-danger" *ngIf="form.controls['answerSR'].errors && form.controls['answerSR'].touched">
        {{ "qna.please_provide_answerSR" | translate }}
      </small>
    </div>

    <div [ngClass]="form.controls['questionEN'].touched ? (form.controls['questionEN'].errors ? 'has-error' : 'has-success') : ''">
      <label for="questionEN">{{ "qna.questionEN" | translate }}</label>
      <input id="questionEN" type="text" placeholder="{{ 'qna.enter_questionEN' | translate }}" class="form-input" formControlName="questionEN" />
      <small class="text-danger" *ngIf="form.controls['questionEN'].errors && form.controls['questionEN'].touched">
        {{ "qna.please_provide_questionEN" | translate }}
      </small>
    </div>

    <div [ngClass]="form.controls['answerEN'].touched ? (form.controls['answerEN'].errors ? 'has-error' : 'has-success') : ''">
      <label for="answerEN">{{ "qna.answerEN" | translate }}</label>
      <textarea id="answerEN" type="text" placeholder="{{ 'qna.enter_answerEN' | translate }}" class="form-input h-40" formControlName="answerEN"></textarea>
      <small class="text-danger" *ngIf="form.controls['answerEN'].errors && form.controls['answerEN'].touched">
        {{ "qna.please_provide_answerEN" | translate }}
      </small>
    </div>
  </div>

  <button type="submit" class="btn btn-primary w-full" [disabled]="isLoading">
    <ng-container *ngIf="isLoading; else alternateTranslation">
      <span class="inline-block h-3 w-3 animate-ping rounded-full bg-white ltr:mr-4 rtl:ml-4"></span>
      {{ "loading" | translate }}
    </ng-container>
    <ng-template #alternateTranslation>
      <span *ngIf="!questionId">{{ "create_label" | translate }}</span>
      <span *ngIf="questionId">{{ "save" | translate }}</span>
    </ng-template>
  </button>
</form>
